var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.8789V6.70694C9.00004 6.50919 9.05871 6.31589 9.1686 6.15148C9.27848 5.98707 9.43465 5.85893 9.61734 5.78326C9.80004 5.70759 10.0011 5.68779 10.195 5.72636C10.389 5.76492 10.5671 5.86013 10.707 5.99994L16.293 11.5859C16.4805 11.7735 16.5858 12.0278 16.5858 12.2929C16.5858 12.5581 16.4805 12.8124 16.293 12.9999L10.707 18.5859C10.5671 18.7257 10.389 18.821 10.195 18.8595C10.0011 18.8981 9.80004 18.8783 9.61734 18.8026C9.43465 18.7269 9.27848 18.5988 9.1686 18.4344C9.05871 18.27 9.00004 18.0767 9 17.8789Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.50c8eb3035bd59141abd185d1173da19.svg";
export { ForwardRef as ReactComponent };